import { Flex, Button, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';

const Paginator = ({
  currentPage,
  totalPages,
  onChange,
  withNavigation = true,
}) => {
  const router = useRouter();

  const currentParams = { ...router.query };

  return (
    <Flex alignItems={'center'} justifyContent={'center'} mt={10}>
      <Button
        name="back"
        onClick={() => {
          withNavigation &&
            router.push({
              pathname: router.pathname,
              query: { ...currentParams, page: currentPage - 1 },
            });
          onChange(currentPage - 1);
        }}
        m={1}
        backgroundColor={'gray.300'}
        _hover={{
          backgroundColor: 'gray.200',
        }}
        isDisabled={currentPage === 1}
        fontWeight={'medium'}
      >
        <MdNavigateBefore />
      </Button>
      <Text m={1} fontSize={14}>
        Page {currentPage} of {totalPages}
      </Text>
      <Button
        name="next"
        onClick={() => {
          withNavigation &&
            router.push({
              pathname: router.pathname,
              query: { ...currentParams, page: currentPage + 1 },
            });
          onChange(currentPage + 1);
        }}
        m={1}
        backgroundColor={'gray.300'}
        _hover={{
          backgroundColor: 'gray.200',
        }}
        isDisabled={currentPage === totalPages}
        fontWeight={'medium'}
      >
        <MdNavigateNext />
      </Button>
    </Flex>
  );
};

export default Paginator;
